export enum IntegrationsCategory {
  All = 'all',
  Communications = 'communications',
  Dispatch = 'dispatch',
  Finance = 'finance',
  VehicleIntegration = 'vehicleIntegration',
}

/**
 * DONE EDIT: KEEP IN SYNC WITH BACKEND 'Integrations' ENUM
 * Enum to represent integrations ID as defined in integrations config.
 */
export enum IntegrationIDs {
  ICabbi = 'icabbi',
  Optibus = 'optibus',
}
